import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { QRCodeSVG } from 'qrcode.react';

import { useState, useRef, useContext } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Col, Row, Modal } from 'react-bootstrap';

import useRequest from '../useRequest';
import { toast } from 'react-toastify';

import AppContext from '../../AppContext';
import Alert from '../Alert';
import Tooltip from '../Tooltip';

import { code } from '../Schema';
import ModalCloseButton from './ModalCloseButton';

import MandatoryFieldNotice from '../MandatoryFieldNotice';

const schema = yup.object().shape({
    code: code,
});

const TwoFAModal = ({ modal, setModal, status, setStatus, auth, url }) => {
    const { request } = useRequest();

    const { Salutations } = useContext(AppContext);
    const formRef = useRef();
    const imgRef = useRef(null);

    const [errorMessage, setErrorMessage] = useState("");

    const closeModal = () => {
        setModal(false);
    }

    const checkData = async (values) => {
        try {
            let result = await request("/User/Set2FA", values);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                toast.success("Zwei-Faktor-Authentisierung wurde erfolgreich aktiviert.");
                setStatus(true);
                setModal(false);
            }
        }
        catch (ex) {
            toast.error(ex.message);
        }
    }

    const disable2FA = async (values) => {
        try {
            let result = await request("/User/Unset2FA", values);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                toast.success("Zwei-Faktor-Authentisierung wurde erfolgreich deaktiviert.");
                setStatus(false);
                setModal(false);
            }
        }
        catch (ex) {
            toast.error(ex.message);
        }
    }

    useEffect(() => {
        if (!modal) return;
        if (!imgRef.current) return;
        if (!url) return;

        const root = createRoot(imgRef.current);
        root.render(<QRCodeSVG value={url} />);
    }, [modal, url])


    return (
        <Modal size="lg" centered show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>
                    {!status && "Zwei-Faktor-Authentisierung aktivieren"}
                    {status && "Zwei-Faktor-Authentisierung deaktivieren"}
                </Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                {errorMessage && <Alert type="error" message={errorMessage} />}

                <Formik
                    innerRef={(f) => (formRef.current = f)}
                    validationSchema={schema}
                    onSubmit={(values) => {
                        if (status) {
                            disable2FA(values);
                        }
                        else {
                            checkData(values);
                        }
                    }}
                    initialValues={{
                        code: '',
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit}>
                                {!status && (
                                    <>
                                        <Form.Group as={Row} className="mb-3" controlId="qr-img">
                                            <Col sm={4} className="col-form-label">
                                                <Form.Label>QR Code</Form.Label>
                                            </Col>
                                            <Col sm={8}>
                                                <div ref={imgRef} id="qrcode-img"></div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3" controlId="qr-auth">
                                            <Col sm={4} className="col-form-label">
                                                <Form.Label>Auth Code</Form.Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Form.Control type="text" disabled name="qr-auth" value={auth} />
                                            </Col>
                                        </Form.Group>
                                    </>
                                )}

                                {status && (
                                    <p>Um die Zwei-Faktor-Authentisierung zu deaktivieren, müssen Sie einen Bestätigungscode aus Ihrem Authenticator eingeben.</p>
                                 ) }
                                
                                <Form.Group as={Row} className="mb-3" controlId="code">
                                    <Col sm={4} className="col-form-label">
                                        <Form.Label className="required">Code eingeben</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Form.Control isInvalid={errors.code && touched.code} type="text" name="code" value={values.code} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.code}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <MandatoryFieldNotice />
                            </Form>
                        )
                    }}
                </Formik>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="secondary" onClick={() => formRef.current.submitForm()}>
                    {!status && "Aktivieren"}
                    {status && "Deaktivieren"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default TwoFAModal;